import { type CandidateFilters, type CandidatePageQuery, type JobFilters } from "@vidario/domain";

import { type UnassignedQuery } from "./endpoints";

/** Namespaced, typed query keys. Centralised so invalidation from mutations
 * stays exact and refactoring a key never drifts callers apart. */
export const queryKeys = {
  health: () => ["health"] as const,
  me: () => ["me"] as const,
  inviteSettings: () => ["users", "invite-settings"] as const,
  jobs: (filters?: JobFilters) => ["jobs", filters ?? {}] as const,
  jobsSummary: () => ["jobs", "summary"] as const,
  job: (id: string) => ["jobs", id] as const,
  candidates: (jobId: string, filters?: CandidateFilters) =>
    ["jobs", jobId, "candidates", filters ?? {}] as const,
  // Under the same ["jobs", jobId, "candidates"] prefix, so the status mutations'
  // invalidation refreshes the page too.
  candidatePage: (jobId: string, query: CandidatePageQuery) =>
    ["jobs", jobId, "candidates", "page", query] as const,
  candidate: (jobId: string, candidateId: string) =>
    ["jobs", jobId, "candidates", candidateId] as const,
  sourcingRun: (jobId: string) => ["jobs", jobId, "sourcing"] as const,
  restartPreview: (jobId: string) => ["jobs", jobId, "sourcing", "restart-preview"] as const,
  placeSuggestions: (query: string) => ["places", query] as const,
  controllingOverview: () => ["controlling"] as const,
  controllingJob: (jobId: number) => ["controlling", jobId] as const,
  // Everything under ["companies"], so one invalidation refreshes the page.
  companyClasses: () => ["companies", "classes"] as const,
  classCompanies: (classId: number) => ["companies", "classes", classId] as const,
  unassignedCompanies: (query: UnassignedQuery) => ["companies", "unassigned", query] as const,
};
